// Transforma a linha crua da fila no nome que a pessoa reconhece.
// Os campos vem do schema real em db/banco.ts -- cliente e razao_social,
// pedido e numero, produto e descricao.

export interface RotuloRegistro {
  icone: string
  titulo: string
}

interface DefinicaoTabela {
  icone: string
  nome: string
  campo?: string
}

const TABELAS: Record<string, DefinicaoTabela> = {
  pedidos: { icone: '📦', nome: 'Pedido', campo: 'numero' },
  sub_pedidos: { icone: '📦', nome: 'Parte do pedido' },
  itens_pedido: { icone: '📦', nome: 'Item do pedido' },
  clientes: { icone: '👤', nome: 'Cliente', campo: 'razao_social' },
  produtos: { icone: '🏷️', nome: 'Produto', campo: 'descricao' },
  representadas: { icone: '🏭', nome: 'Fornecedora', campo: 'nome' },
  tabelas_preco: { icone: '💲', nome: 'Tabela de preço', campo: 'nome' },
  precos: { icone: '💲', nome: 'Preço' },
  visitas: { icone: '📍', nome: 'Visita' },
  compromissos: { icone: '📅', nome: 'Compromisso', campo: 'assunto' },
  segmentos: { icone: '🏷️', nome: 'Segmento', campo: 'nome' },
  metas: { icone: '🎯', nome: 'Meta' },
  regras_comissao: { icone: '💰', nome: 'Regra de comissão' },
  lancamentos_comissao: { icone: '💰', nome: 'Lançamento de comissão' },
  diferencas_comissao: { icone: '💰', nome: 'Diferença de comissão' },
  empresas: { icone: '🏢', nome: 'Dados da empresa' },
}

function textoDoCampo(valor: unknown): string | null {
  if (typeof valor === 'number') return String(valor)
  if (typeof valor !== 'string') return null
  const limpo = valor.trim()
  return limpo === '' ? null : limpo
}

export function rotuloDoRegistro(
  tabela: string,
  registro: Record<string, unknown>,
): RotuloRegistro {
  const definicao = TABELAS[tabela]
  if (!definicao) return { icone: '📄', titulo: tabela }

  const texto = definicao.campo ? textoDoCampo(registro[definicao.campo]) : null
  return {
    icone: definicao.icone,
    titulo: texto ? `${definicao.nome} ${texto}` : definicao.nome,
  }
}
